<template>
    <div class="phone-card" :style="{ backgroundImage: `url(${backgroundImage})` }">
        <div class="flex flex-col h-full w-full">
            <p class="font-bold text-xl text-white" v-html="trans.get('account.phone_card.title')"></p>
            <p class="leading-6 mb-2 text-white" v-html="trans.get('account.phone_card.this_number_shows_during_a_call')"></p>

            <div class="flex h-full items-center">
                <div class="rounded-md bg-white text-primary p-1.5 inline-block text-xl font-bold mb-2">
                    <a :href="'tel:' + phoneNumber">
                        <font-awesome-icon :icon="['far', 'mobile-screen-button']"/>
                        {{ phoneNumber }}
                    </a>
                </div>
            </div>

            <p class="leading-6 text-white" v-html="trans.get('account.phone_card.remember_this_phone')"></p>
        </div>
    </div>
</template>

<style lang="scss">
.phone-card {
    @apply shadow-small rounded-2xl bg-customer-care bg-right-bottom bg-contain bg-no-repeat text-white h-full w-full max-w-full mx-auto p-3;
}
</style>

<script>
export default {
    name: 'PhoneCard',
    props: {
        backgroundImage: {
            type: String,
            default: '/assets/image/home/phone.png'
        }
    },
    computed: {
        phoneNumber() {
            return this.config.get('app.phone_number_customer_care');
        }
    }
}
</script>
